<p-panel styleClass="no-padding-panel panel-shadow">
  <p-header>
    <div class="panel-header">Additional Costs</div>
  </p-header>
  <div *ngIf="additionalCosts.length > 0">
    <p-table
      [value]="additionalCosts"
      [responsive]="true"
      tableStyleClass="table-no-top-corners"
      styleClass="no-border-table table-no-bottom-corners"
      [(selection)]="selectedAdditionalCharge"
      selectionMode="single"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Job Completed Date</th>
          <th class="small-expense-width">Charge Type</th>
          <th class="small-expense-width">Vehicle Reg.</th>
          <th>Customer</th>
          <th class="small-amount-width">Amount</th>
          <th class="big-description-width">Description</th>
          <th class="small-photo-width">Photo</th>
          <th>Validation Status</th>
          <th>Additional Cost Logged</th>
          <th>Assignee</th>
          <th class="small-expense-width">Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-itemUntyped>
        <ng-container *ngIf="asVmeExpense(itemUntyped) as item">
          <tr [pSelectableRow]="item">
            <td class="text-center">
              <div>
                {{ jobCancelledOrClosedDate | datex : 'ddd Do MMM' }}
              </div>
              <div>
                {{ jobCancelledOrClosedDate | datex : 'HH:mm' }}
              </div>
            </td>
            <td class="small-expense-width">{{ item.additionalChargeType.chargeType }}</td>
            <td class="small-expense-width">{{ item.task?.vehicle?.registrationNumber }}</td>
            <td>
              <div>{{ item.task.customer.name }}</div>
              <div class="opacity-50 text-xs">{{ getCustomerInvoicePeriodText(item) }}</div>
            </td>
            <td class="small-amount-width text-center">
              <b>{{ item.chargeAmount | currency : 'GBP' : 'symbol' : '1.2-2' }} </b>
              <i
                *ngIf="item.isAutomaticallyGenerated"
                class="fa fa-info-circle"
                [escape]="false"
                pTooltip="Auto Generated"
              ></i>
            </td>
            <td class="big-description-width">
              <span>{{ item.otherCharge }}</span>
              <span *ngIf="item.proRatedChargingTimeDuration != null">
                <!--Using ProRated because charging and waiting time duration is non-nullable and therefore returns null -->
                <div *ngIf="item.started != null" class="new-line">
                  <b>Started:</b> {{ item.started | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                </div>
                <div *ngIf="item.ended != null" class="new-line">
                  <b>Ended:</b> {{ item.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                </div>
                <div *ngIf="item.chargingTimeDuration != null" class="new-line">
                  <b>Total duration:</b>
                  {{ formatChargingWaitingDuration(item.chargingTimeDuration) }}
                </div>
                <div *ngIf="item.proRatedChargingTimeDuration != null" class="new-line">
                  <b>ProRated duration</b>
                  {{ formatChargingWaitingDuration(item?.proRatedChargingTimeDuration) }}
                </div>
              </span>

              <span *ngIf="item.proRatedWaitingTimeDuration != null">
                <div *ngIf="item.started != null" class="new-line">
                  <b>Started:</b> {{ item.started | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                </div>
                <div *ngIf="item.ended != null" class="new-line">
                  <b>Ended:</b>
                  {{ item.ended | datex : "ddd DD MMM 'YY HH:mm:ss" }}
                </div>
                <div *ngIf="item.waitingTimeDuration != null" class="new-line">
                  <b>Total duration:</b>
                  {{ formatChargingWaitingDuration(item.waitingTimeDuration) }}
                </div>
                <div *ngIf="item.proRatedWaitingTimeDuration != null" class="new-line">
                  <b>ProRated duration</b>
                  {{ formatChargingWaitingDuration(item?.proRatedWaitingTimeDuration) }}
                </div>
              </span>
            </td>
            <td class="small-photo-width text-center">
              <a
                *ngIf="item.photographPublicUrl"
                style="cursor: pointer"
                (click)="openPhoto(item.photographPublicUrl, item.photographLocation)"
              >
                <i class="material-icons">photo_camera</i>
                <div>View</div>
              </a>
            </td>
            <td class="text-center">
              <a
                style="cursor: pointer"
                (click)="selectedAdditionalCharge = item; showValidationResult = true"
                [class]="autoValidationClass(item)"
                >{{ item.autoApprovalStatus?.name | camelToSentenceCase }}</a
              >
            </td>
            <td class="text-center">
              <div>{{ item.createdOn | datex : 'ddd Do MMM' }}</div>
              <div>{{ item.createdOn | datex : 'HH:mm' }}</div>
            </td>
            <td class="text-center">
              <span *ngIf="!isChangeExpenseStatusAvailable(item)">
                {{ item?.latestActionByUserName }}
              </span>
              <span
                *ngIf="isChangeExpenseStatusAvailable(item)"
                (click)="openChangeAssigneeDialog(item?.latestActionByUserId, item?.id)"
                class="link-style edit-assignee"
              >
                {{ item?.latestActionByUserName || 'Assign' }}
              </span>
            </td>
            <td class="small-expense-width" style="text-align: center">
              <div
                class="text-center approved-declined"
                [ngClass]="getApprovalStatusClass(item)"
                [class.editable]="isChangeExpenseStatusAvailable(item)"
                (click)="onChangeExpenseStatus(item)"
              >
                {{ item.additionalChargeStatus?.name }}
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>

  <p-footer class="no-rounded-top-border">
    <div style="">
      <div style="text-align: right">
        <button
          *ngIf="
            organisationTypeId == OrganisationType.Engineius ||
            organisationTypeId == OrganisationType.Supplier
          "
          type="button"
          pButton
          icon="fa ui-icon-add"
          label="Add Additional Cost"
          class="ui-button btn-mobile-block mb-2"
          (click)="addAdditionalCharge()"
          [disabled]="addDisabled"
        ></button>
        <button
          *ngIf="
            organisationTypeId == OrganisationType.Engineius ||
            organisationTypeId == OrganisationType.Supplier
          "
          type="button"
          pButton
          icon="fa ui-icon-edit"
          label="Edit"
          class="ui-button btn-mobile-block mb-2"
          (click)="editAdditionalCharge(selectedAdditionalCharge.id)"
          [disabled]="editDisabled"
        ></button>
        <button
          *ngIf="
            organisationTypeId == OrganisationType.Engineius ||
            organisationTypeId == OrganisationType.Supplier
          "
          type="button"
          pButton
          icon="fa ui-icon-trash"
          label="Delete"
          [disabled]="deleteDisabled"
          class="ui-button red-btn btn-mobile-block mb-2"
          (click)="deleteAdditionalCharge(selectedAdditionalCharge)"
        ></button>
        <button
          *ngIf="organisationTypeId == OrganisationType.Engineius"
          type="button"
          pButton
          icon="fa ui-icon-keyboard-return"
          label="Decline"
          [disabled]="declineDisabled"
          class="ui-button orange-btn btn-mobile-block mb-2"
          (click)="showDeclineAdditionalCharge()"
        ></button>
        <button
          *ngIf="organisationTypeId == OrganisationType.Engineius"
          type="button"
          pButton
          icon="fa fa-envelope"
          label="Internal Request"
          [disabled]="requestInfoDisabled"
          class="ui-button orange-btn btn-mobile-block mb-2"
          (click)="showEngineiusRequestExpenseDialog()"
        ></button>
        <button
          *ngIf="organisationTypeId == OrganisationType.Engineius"
          type="button"
          pButton
          icon="fa fa-envelope"
          label="Request Info"
          [disabled]="requestInfoDisabled"
          class="ui-button orange-btn btn-mobile-block mb-2"
          (click)="showRequestInfo()"
        ></button>
        <button
          *ngIf="organisationTypeId == OrganisationType.Engineius"
          type="button"
          pButton
          icon="fa ui-icon-check-circle"
          label="Auto Validate"
          class="ui-button secondary btn-mobile-block mb-2"
          (click)="autoValidateAdditionalCharge()"
          [disabled]="autoValidateDisabled"
        ></button>
        <button
          *ngIf="organisationTypeId == OrganisationType.Engineius"
          type="button"
          pButton
          icon="fa ui-icon-check"
          label="Approve"
          [disabled]="approveDisabled"
          class="ui-button green-btn btn-mobile-block mb-2"
          (click)="showApproveAdditionalCharge(selectedAdditionalCharge)"
        ></button>
      </div>
    </div>
  </p-footer>
</p-panel>

<p-dialog
  [header]="(editingAdditionalCharge ? 'Edit' : 'Add') + ' Additional Cost'"
  [(visible)]="showUpsertDialog"
  [responsive]="true"
  [modal]="false"
  [style]="{ width: '500px', height: '600px;' }"
  (onHide)="savingApproval = false"
>
  <div class="ui-g" style="position: relative; min-height: 280px; overflow-y: auto">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Charge Type</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="chargeTypeOptions"
          name="additionalChargeTypes"
          filter="true"
          [style]="{ width: '100%' }"
          [(ngModel)]="additionalChargeToUpsert.additionalChargeTypeId"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Task No</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="taskOptions"
          name="taskNumbers"
          [style]="{ width: '100%' }"
          [(ngModel)]="additionalChargeToUpsert.taskId"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Amount (£)</label>
      </div>
      <div class="ui-grid-col-8">
        <input
          [(ngModel)]="additionalChargeToUpsert.chargeAmount"
          [style]="{ width: '100%' }"
          pInputText
          maxlength="10"
          (keydown)="inputHelper.allowNumberInputKey($event)"
          (keyup)="inputHelper.fixDigitsAndMax($event.target, 1000000)"
          [disabled]="isAddAdditionalCostReadOnly()"
        />
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Description</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea
          name="otherCharge"
          maxlength="255"
          style="width: 100%; height: 50px"
          [(ngModel)]="additionalChargeToUpsert.otherCharge"
          id="otherCharge"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></textarea>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Photo</label>
      </div>
      <div class="ui-grid-col-8">
        <p-fileUpload
          *ngIf="showUpsertDialog"
          name="files"
          url="/api/filestorage/fileuploading"
          (onBeforeUpload)="onBeforeUpload($event)"
          (onSelect)="onSelect($event)"
          (onError)="onError($event)"
          (onUpload)="onAdditionalCostFileUpload($event)"
          withCredentials="true"
          [maxFileSize]="83886080"
          [accept]="'application/pdf,image/*,.heic'"
          auto="true"
          chooseLabel="Upload Photo"
          mode="basic"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></p-fileUpload>
        <div style="height: 25px">
          <a
            *ngIf="additionalChargeToUpsert.photographLocation"
            style="cursor: pointer"
            (click)="openPhotoPresigned(additionalChargeToUpsert.photographLocation)"
          >
            <i class="material-icons">photo_camera</i>
          </a>
        </div>

        <!--<input name="photographLocation" pInputText style="width: 100%"
        [(ngModel)]="additionalCharge.photographLocation" id="photographLocation" />-->
      </div>
    </div>
  </div>
  <p-footer class="no-rounded-top-border rounded-bottom-border">
    <div style="text-align: right">
      <button
        type="button"
        (click)="closeAdditionalChargeUpsertDialog()"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        [disabled]="saveAdditionalChargeDisabled() || savingApproval"
        (click)="saveAdditionalCharge()"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-confirmDialog #cd key="delete-charge" closable="false" [style]="{ width: '425px' }">
  <p-footer class="rounded-bottom-border">
    <button
      type="button"
      pButton
      class="ui-button ui-button-tertiary"
      label="No"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      class="ui-button ui-button-danger"
      label="Yes - Delete"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<p-dialog
  header="Approve Additional Cost"
  [(visible)]="showApproveAdditionalChargeDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px', height: '530px' }"
  (onHide)="processingApproval = false"
>
  <div class="ui-g" *ngIf="approveRequest">
    <div class="ui-g-12">
      <p><b>Who is paying for this service?</b></p>
      <div class="ui-grid-col-10">
        <label>Customer</label> <br />
        <small>Eng. is recovering the cost from the customer</small>
      </div>
      <div class="ui-grid-col-2">
        <p-checkbox
          name="approveRequest.chargeCustomer"
          binary="true"
          (onChange)="handleChargeableEntityChange($event, 'approveRequest.chargeCustomer')"
          [(ngModel)]="approveRequest.chargeCustomer"
          id="approveRequest.chargeCustomer"
          [disabled]="approveRequest.customerRatesAreExpenseInclusive"
          pTooltip="Customer rates are expense inclusive"
          [tooltipDisabled]="!approveRequest.customerRatesAreExpenseInclusive"
        ></p-checkbox>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-10">
        <label>Engineius Agreed</label><br /><small
          >Eng. is recovering the cost from a 3rd Party</small
        >
      </div>
      <div class="ui-grid-col-2">
        <p-checkbox
          name="approveRequest.chargeEngineiusCustomer"
          binary="true"
          (onChange)="
            handleChargeableEntityChange($event, 'approveRequest.chargeEngineiusCustomer')
          "
          [(ngModel)]="approveRequest.chargeEngineiusCustomer"
          id="approveRequest.chargeEngineiusCustomer"
        ></p-checkbox>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-10">
        <label>Out of Job Profit</label><br /><small
          >This is coming from the profit of the job</small
        >
      </div>
      <div class="ui-grid-col-2">
        <p-checkbox
          name="isNoCharge"
          binary="true"
          (onChange)="handleChargeableEntityChange($event, 'isNoChargeRequired')"
          [(ngModel)]="isNoChargeRequired"
          id="approveRequest.chargeEngineiusCustomer2"
        ></p-checkbox>
      </div>
    </div>

    <div class="ui-g-12">
      <p><b>Who is being paid for this service?</b></p>
      <div class="ui-grid-col-10">
        <label>Supplier</label> <br /><small>The supplier is being paid for this service</small>
      </div>
      <div class="ui-grid-col-2">
        <p-checkbox
          name="approveRequest.chargeSupplier"
          binary="true"
          (onChange)="handleChargeableEntityChange($event, 'approveRequest.chargeSupplier')"
          [(ngModel)]="approveRequest.chargeSupplier"
          id="approveRequest.chargeSupplier"
        ></p-checkbox>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-10">
        <label>Engineius</label> <br /><small
          >Eng. is being paid for a cost it incurred e.g. Ferry cost</small
        >
      </div>
      <div class="ui-grid-col-2">
        <p-checkbox
          name="approveRequest.chargeEngineiusSupplier"
          binary="true"
          (onChange)="
            handleChargeableEntityChange($event, 'approveRequest.chargeEngineiusSupplier')
          "
          [(ngModel)]="approveRequest.chargeEngineiusSupplier"
          id="approveRequest.chargeEngineiusSupplier"
        ></p-checkbox>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-10">
        <label>No Payment</label> <br /><small>Additional profit on the job</small>
      </div>
      <div class="ui-grid-col-2">
        <p-checkbox
          name="isNoPaymentRequired"
          binary="true"
          (onChange)="handleChargeableEntityChange($event, 'isNoPaymentRequired')"
          [(ngModel)]="isNoPaymentRequired"
          id="approveRequest.chargeEngineiusSupplier2"
        ></p-checkbox>
      </div>
    </div>
  </div>

  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button
        type="button"
        (click)="showApproveAdditionalChargeDlg = false"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        [icon]="processingApproval ? 'pi pi-spin pi-spinner' : 'fa ui-icon-check'"
        label="Approve"
        [disabled]="approveFormInvalid()"
        class="ui-button green-btn ui-button-primary"
        (click)="approveAdditionalCharge()"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<change-expense-status
  *ngIf="showChangeExpenseStatusDialog"
  [(visible)]="showChangeExpenseStatusDialog"
  [selectedStatus]="selectedStatus"
  [statusAdditionalChargeId]="statusAdditionalChargeId"
  (confirmChangeStatus)="saveChangeStatus($event)"
></change-expense-status>

<change-assignee
  *ngIf="showChangeAssigneeDialog"
  [(visible)]="showChangeAssigneeDialog"
  [selectedAssignee]="selectedAssignee"
  [assigneeAdditionalChargeId]="assigneeAdditionalChargeId"
  (assigneeChanged)="onAssigneeChanged()"
></change-assignee>

<decline-additional-charge
  *ngIf="showRejectionDialog"
  [(visible)]="showRejectionDialog"
  (confirmDeclineCharge)="declineAdditionalCharge(selectedAdditionalCharge)"
  [additionalCharge]="selectedAdditionalCharge"
>
</decline-additional-charge>

<request-additional-info
  *ngIf="showRequestInfoDialog"
  [(visible)]="showRequestInfoDialog"
  (requestInfoComplete)="updateIncidentAndLoadAdditionalCharge()"
  [additionalCharge]="selectedAdditionalCharge"
>
</request-additional-info>

<additional-internal-request
  *ngIf="showEngineiusRequestDialog"
  [(visible)]="showEngineiusRequestDialog"
  (onSuccess)="updateIncidentAndLoadAdditionalCharge()"
  [additionalCharge]="selectedAdditionalCharge"
>
</additional-internal-request>

<ngx-gallery
  *ngIf="expenseImages.length > 0"
  [options]="expenseGalleryOptions"
  [images]="expenseImages"
  (previewClose)="onExpenseImagePreviewClose()"
></ngx-gallery>

<app-vme-expense-validation-result
  *ngIf="showValidationResult"
  [(showValidationResult)]="showValidationResult"
  [organisationTypeId]="organisationTypeId"
  [selectedAdditionalCharge]="selectedAdditionalCharge"
  [formatChargingWaitingDuration]="formatChargingWaitingDuration"
></app-vme-expense-validation-result>
